import { create } from 'zustand'
import ApiClient from '../views/api/client'
import { toast } from 'react-toastify'

const apiClient = new ApiClient()

export const useClientStore = create((set, get) => ({
  clients: [],
  showDeleteModal: false,
  clientToDelete: null,
  error: null,
  editingClient: null,
  showUpdateModal: false,
  loading: false,

  // //client search state
  // setClients: (clients) => {
  //   set({ clients, filteredClients: clients })
  // },

  // setSearchQuery: (query) => {
  //   set({ searchQuery: query })
  //   get().filterClients(query)
  // },

  // filterClients: (query) => {
  //   const lowerQuery = query.toLowerCase()
  //   const { clients } = get()

  //   const filtered = clients.filter(
  //     (client) =>
  //       client?.client_name?.toLowerCase().includes(lowerQuery) ||
  //       client?.id?.toString().includes(lowerQuery) ||
  //       client?.program?.name?.toLowerCase().includes(lowerQuery)
  //   )

  //   set({ filteredClients: filtered })
  // },

  // modal for deleting client
  openDeleteModal: (client) => {
    set({ showDeleteModal: true, clientToDelete: client })
  },

  closeDeleteModal: () => {
    set({ showDeleteModal: false, clientToDelete: null })
  },

  // modal for updating client
  openUpdateModal: (client) => {
    set({ editingClient: client, showUpdateModal: true })
  },

  closeUpdateModal: () => {
    set({ editingClient: null, showUpdateModal: false })
  },

  // modal for adding new client
  openAddClientModal: () => {
    set({ showAddClientModal: true })
  },

  closeAddClientModal: () => {
    set({ showAddClientModal: false })
  },
  // // Get All Client
  // getClientDetail: async (clientId) => {
  //   try {
  //     set({ loading: true })
  //     const response = await apiClient.getClientDetails(clientId)
  //     set((state) => ({
  //       clients: [...state.clients, response.data],
  //       loading: false,
  //       error: null,
  //     }))
  //     return {
  //       success: true,
  //       message: `${response.data} fetched successfully!`,
  //     }
  //   } catch (err) {
  //     console.log('Error fetching client', err)
  //     set({ loading: true, error: err.response?.data?.detail || err.message })

  //     return { success: false, message: 'Failed to fetch client' }
  //   }
  // },

  // Add New Client
  addNewClient: async (name, email, image, program) => {
    try {
      set({ loading: true })
      const response = await apiClient.createClient(name, email, image, program)
      set((state) => ({
        clients: [...state.clients, response.data],
        loading: false,
        error: null,
      }))
      // if (response.data) {
      //   toast.success(`${name} added successfuly!`, {
      //     position: 'top-right',
      //     autClose: 3000,
      //     theme: 'colored',
      //   })
      // }
      return { success: true, message: `${response.data} created successfuly!` }
    } catch (err) {
      console.error('Add Client Error:', err)
      set({ loading: false, error: err.response?.data?.detail || err.message })

      // if (err) {
      //   toast.error(err, {
      //     position: 'top-right',
      //     autClose: 3000,
      //     theme: 'colored',
      //   })
      // }

      return { success: false, message: 'Failed to create client!' }
    }
  },

  // delete state
  deleteClient: async (clientId) => {
    try {
      // const clientDeleted = get().clients.filter(c=> c.id === clientId)

      const { data, error } = await apiClient.deleteClient(clientId)
      if (error) throw new Error(error)

      // Filter out deleted client
      const updatedClients = get().clients.filter((c) => c.id !== clientId)
      set({ clients: updatedClients })

      // toast.success(`${data} deleted successfuly!`, {
      //   position: 'top-right',
      //   autClose: 3000,
      //   theme: 'colored',
      // })
      return { success: true, message: `${data} deleted successfully!` }
    } catch (err) {
      set({ error: 'Failed to delete client!' })

      // toast.error(err, {
      //   position: 'top-right',
      //   autClose: 3000,
      //   theme: 'colored',
      // })

      return { success: false, message: 'Failed to delete client!' }
    }
  },

  // Update logic
  updateClient: async (clientId, name, email, image, programId, status) => {
    try {
      const { data, error } = await apiClient.updateClientDetails(
        clientId,
        name,
        email,
        image,
        programId,
        status
      )
      if (data) {
        const updatedClients = get().clients.map((c) =>
          c.id === clientId ? data : c
        )
        set({
          clients: updatedClients,
          editingClient: null,
          showUpdateModal: false,
        })
        // toast.success('User info updated successfully!', {
        //   position: 'top-right',
        //   autClose: 3000,
        //   theme: 'colored',
        // })
      } else {
        // toast.error(error || 'Client does not exist!', {
        //   position: 'top-right',
        //   autClose: 3000,
        //   theme: 'colored',
        // })
      }
    } catch (err) {
      console.error('Error updating client', err)
      // toast.error(err, {
      //   position: 'top-right',
      //   autClose: 3000,
      //   theme: 'colored',
      // })
    }
  },

  setError: (err) => set({ error: err }),
}))
